import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/index'
import { getToken } from '@/utils/auth'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
if(onResolve || onReject) {
  return originalPush.call(this, location, onResolve, onReject)
}
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
export const constantRoutes = [
  {
    path: '/',
    component: Home,
    redirect: '/home',
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/home',
    component: () => import('@/views/home/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  }
]
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
router.beforeEach((to, from, next) => {
  if (!getToken() && to.path !== '/login') {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (getToken() && to.path === '/login') {
    next({
      path: '/home'
    })
  } else {
    next()
  }
})

export default router
